import React from 'react';

function Access() {
  return (
    <section id="access" className="map-section">
      <div className="container">
        <h2 className="section-title">アクセス</h2>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39876.42096929489!2d142.33650186558884!3d43.80486104812758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f0ce458db8504ef%3A0xacb75c1f3e545e2a!2z44KI44GX6a6o!5e0!3m2!1sja!2sjp!4v1766914981721!5m2!1sja!2sjp"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="よし鮨の地図"
          ></iframe>
        </div>
        <div className="access-info">
          <div className="access-item">
            <div className="access-icon">🚗</div>
            <div className="access-content">
              <strong>お車でお越しの場合</strong>
              <p>旭川駅から約20分。旭川鷹栖ICから約10分。旭川北ICから約12分。店舗前に3台分の駐車場がございます。</p>
            </div>
          </div>
          <div className="access-item">
            <div className="access-icon">🚌</div>
            <div className="access-content">
              <strong>バスでお越しの場合</strong>
              <p>道北バス「春光台2条3丁目」下車、徒歩1分。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Access;

